// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__2fgKW","log":"ModalInventoryLogs_log__1FjUt","date":"ModalInventoryLogs_date__20XSB","userName":"ModalInventoryLogs_userName__3lCJp"};